import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { getTaskTypeLabel } from "@common/constants/taskTypeDefinitions";
import { TaskType } from "@common/types/task";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CloseTemplateTaskRow } from "../closeTemplateTasksViewConfig";

export const CloseTemplateTaskTypeCell = memo(
    function CloseTemplateTaskTypeCell({
        row,
    }: CellContext<ViewTableFeatures, CloseTemplateTaskRow, TaskType | null>) {
        const item = row.original;

        if (item.isGroupRow) {
            return null;
        }

        return (
            <ViewTableCell>
                <span>
                    {item.taskType != null
                        ? (getTaskTypeLabel(item.taskType) ?? item.taskType)
                        : "-"}
                </span>
            </ViewTableCell>
        );
    },
);
